import { useCookieConsent } from '@packages/shared';

const dispatchMouseflow = (tagName: string) => {
  // eslint-disable-next-line no-underscore-dangle
  (window as any)._mfq = (window as any)._mfq || [];
  // eslint-disable-next-line no-underscore-dangle
  (window as any)._mfq.push(['tag', tagName]);
};

/**
 * Coookie consent dependent hook to push mouseflow tracking data.
 *
 * @param tagName the mouseflow tagname
 */
export const useMouseflowData = (): ((tagName: string) => void) => {
  const isConsentGiven = useCookieConsent('C0003');
  if (!isConsentGiven) {
    return () => {};
  }

  return (tagName: string) => dispatchMouseflow(tagName);
};
